"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class Events {
  constructor() {
    this.eventList = [];
  }
  add(type, event, options) {
    document.addEventListener(type, event, options);
    this.eventList.push({
      target: document,
      type,
      event,
      options
    });
  }
  addToTarget(target, type, event, options) {
    target.addEventListener(type, event, options);
    this.eventList.push({
      target,
      type,
      event,
      options
    });
  }
  clear() {
    this.eventList.forEach(_ref => {
      let {
        target,
        type,
        event,
        options
      } = _ref;
      target.removeEventListener(type, event, options);
    });
    this.eventList = [];
  }
}
exports.default = Events;